import { AxModal, AxDropdown, IAxDropdownOptions, AxFormValidation, AxInput, IAxFormValidationOptions } from "@axess/limestone";
import * as Rental from "../RiderDetailsModule";
import * as models from "../RiderDetailsModelBundle";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import { AxStaticConfigModule } from "../../../AxConfig/AxStaticConfigModule";
import { ConfigHelper, ConfigDefinition } from "../../../../Lib/Helper/Config/ConfigHelper";
import { MaskedTextChangedListener } from 'ts-input-mask';
import { I18nHelper, Translations } from "../../../../Lib/Helper/I18nHelper";

export class PersonDataForm {
    private formName = '#personDataForm';

    private unitSystem: number;

    private heightDropDown = new AxDropdown();
    private weightDropDown = new AxDropdown();
    private shoeSizeDropDown = new AxDropdown();
    private shoeSizeSystemDropDown = new AxDropdown();

    private countryDropDown = new AxDropdown();
    private genderDropDown = new AxDropdown();
    private skillLevelDropDown = new AxDropdown();

    private riderDetailsModule: Rental.RiderDetailsModule;

    constructor(unitSystem: number) {
        this.unitSystem = unitSystem;
        this.riderDetailsModule = AxLoad.GetModule<Rental.RiderDetailsModule>("RiderDetailsModule");
    }

    async initInputsAsync(productAndRiderDetails: models.ProductAndRiderDetails) {
        return new Promise<void>((resolve) => {
            this.initInputValidation();
            this.initUnitSelectionRadios(productAndRiderDetails);

            ConfigHelper.getBoolConfigValueAsync(ConfigDefinition.RentalDataTextInput)
                .then(async useTextInput => {
                    if (productAndRiderDetails != null &&
                        productAndRiderDetails.riderData != null &&
                        productAndRiderDetails.riderData != undefined) {
                        this.initTextInputs(productAndRiderDetails, useTextInput);
                        this.initDropDowns(productAndRiderDetails, useTextInput);
                        await this.setValueFromProductAndRiderDetailsToForm(productAndRiderDetails, useTextInput);
                        resolve();
                    }
                });
        });
    }

    private initInputValidation() {
        let validationFormOptions = {
            selector: '#personDataForm',
            rules: this.getValidationRules(),
            callback: (form: HTMLElement) => {
                //this.submitPersonDataForm();
            }
        }

        let form = document.getElementById('personDataForm');

        let inputs = form.getElementsByClassName("ax-form-control");

        new AxFormValidation(validationFormOptions).init();

        for (let i = 0; i < inputs.length; i++) {
            let input = inputs.item(i) as HTMLInputElement;

            if (input.id.length === 0) {
                continue;
            }

            new AxInput('#' + input.id).init();
        }

        const i18nHelper = new I18nHelper();

        $("#heightFeet, #heightInch").on("keyup change", function () {
            const otherField = this.id === "heightFeet" ? "#heightInch" : "#heightFeet";
            $(otherField).valid();
        });

        $.validator.addMethod(
            "maxHeight",
            function (value, element, params) {
                const feet = Number($("#heightFeet").val()) || 0;
                const inches = Number($("#heightInch").val()) || 0;

                const totalInches = feet * 12 + inches;
                const maxInches = params.maxFeet * 12 + params.maxInches;

                return totalInches <= maxInches;
            },
            function (params) {
                return i18nHelper.GetTranslation(Translations.MaxRentalHeight, params.maxFeet, params.maxInches);
            }
        );
    }

    private initUnitSelectionRadios(productAndRiderDetails: models.ProductAndRiderDetails) {
        const radios: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="unit"]');

        radios.forEach(radio => {
            radio.addEventListener('change', (event) => {
                const selectedVal = $(event.currentTarget).val();
                productAndRiderDetails.riderData.unitSystem = Number(selectedVal);
                this.riderDetailsModule.loadAccountData(productAndRiderDetails.customerAccountNr);
            });
        });
    }

    private initTextInputs(productAndRiderDetails: models.ProductAndRiderDetails, useTextInput: boolean) {
        if ($('#City').length > 0) {
            $('#City').on('input', e => {
                productAndRiderDetails.riderData.city = $('#City').val().toString();
            });
        }

        if ($('#Phone').length > 0) {
            $('#Phone').on('input', e => {
                productAndRiderDetails.riderData.phone = $('#Phone').val().toString();
            });
        }

        if ($('#State').length > 0) {
            $('#State').on('input', e => {
                productAndRiderDetails.riderData.state = $('#State').val().toString();
            });
        }

        if ($('#Street').length > 0) {
            $('#Street').on('input', e => {
                productAndRiderDetails.riderData.street = $('#Street').val().toString();
            });
        }

        if ($('#ZipCode').length > 0) {
            $('#ZipCode').on('input', e => {
                productAndRiderDetails.riderData.zipCode = $('#ZipCode').val().toString();
            });
        }

        if (useTextInput) {
            if (this.unitSystem === 1) // imperial == 1
            {
                if ($('#heightFeet').length > 0) {
                    $('#heightFeet').on('input', e => {
                        productAndRiderDetails.riderData.height = Number(this.getInchesToM());
                    });
                }

                if ($('#heightInch').length > 0) {
                    $('#heightInch').on('input', e => {
                        productAndRiderDetails.riderData.height = Number(this.getInchesToM());
                    });
                }

                if ($('#Weight').length > 0) {
                    $('#Weight').on('input', e => {
                        const weightInLbs = Number($('#Weight').val().toString());
                        productAndRiderDetails.riderData.weight = this.lbsToKg(weightInLbs);
                    });
                }
            } else {
                if ($('#Height').length > 0) {
                    $('#Height').on('input', e => {
                        const heightInMeter = Number($('#Height').val().toString());
                        productAndRiderDetails.riderData.height = heightInMeter;
                    });
                }

                if ($('#Weight').length > 0) {
                    $('#Weight').on('input', e => {
                        productAndRiderDetails.riderData.weight = Number($('#Weight').val().toString());
                    });
                }
            }
        }
    }

    private kgToLbs(kg: number): number {
        const lbs = kg * 2.2046;
        return lbs;
    }

    private lbsToKg(lbs: number): number {
        return lbs * 0.45359237;
    }

    private metersToInches(meters: number): number {
        const inches = meters * 39.37;
        return inches;
    }

    private getInchesToM(): number {
        const inches = this.getHeightInches();
        const meters = inches / 39.370;
        return parseFloat(meters.toFixed(2));
    }

    private getHeightInches() {
        let feet = parseInt($('#heightFeet').val() as string);
        let inches = parseInt($('#heightInch').val() as string);

        let convertedInches = this.convertFeetAndInchesToInches(feet, inches);
        return convertedInches;
    }

    private convertFeetAndInchesToInches(feet: number, inches: number) {
        // Convert feet to inches by multiplying by 12
        let totalInches = feet * 12;
        // Add the remaining inches
        totalInches += inches;
        // Return the total inches
        return totalInches;
    }

    private initDropDowns(productAndRiderDetails: models.ProductAndRiderDetails, useTextInput: boolean) {
        this.initCountryDropDown(productAndRiderDetails);
        this.initGenderDropDown(productAndRiderDetails);
        this.initSkillLevelDropDown(productAndRiderDetails);
        this.initShoeSizeSystemDropDown(productAndRiderDetails);
        this.initShoeSizeDropDown(productAndRiderDetails);

        if (!useTextInput) {
            this.initHeightDropDown(productAndRiderDetails);
            this.initWeightDropDown(productAndRiderDetails);
        }
    }

    private async setValueFromProductAndRiderDetailsToForm(productAndRiderDetails: models.ProductAndRiderDetails, useTextInput: boolean) {
        return new Promise<void>((resolve) => {

            if ($('#City').length > 0) {
                $('#City').val(productAndRiderDetails.riderData.city);
                $('#City').text(productAndRiderDetails.riderData.city);
            }

            if ($('#Phone').length > 0) {
                $('#Phone').val(productAndRiderDetails.riderData.phone);
                $('#Phone').text(productAndRiderDetails.riderData.phone);
            }

            if ($('#State').length > 0) {
                $('#State').val(productAndRiderDetails.riderData.state);
                $('#State').text(productAndRiderDetails.riderData.state);
            }

            if ($('#Street').length > 0) {
                $('#Street').val(productAndRiderDetails.riderData.street);
                $('#Street').text(productAndRiderDetails.riderData.street);
            }

            if ($('#ZipCode').length > 0) {
                $('#ZipCode').val(productAndRiderDetails.riderData.zipCode);
                $('#ZipCode').text(productAndRiderDetails.riderData.zipCode);
            }

            if (useTextInput) {
                if (this.unitSystem === 1) {

                    if (productAndRiderDetails.riderData.height != undefined || productAndRiderDetails.riderData.height != null) {

                        const heightInInches = this.metersToInches(productAndRiderDetails.riderData.height);

                        let feet = Math.floor(heightInInches / 12);
                        let inches = Math.ceil(heightInInches % 12);

                        $('#heightFeet').val(feet).trigger('change');
                        $('#heightFeet').text(feet);

                        $('#heightInch').val(inches).trigger('change');
                        $('#heightInch').text(inches);
                    }

                    if (productAndRiderDetails.riderData.weight != undefined || productAndRiderDetails.riderData.weight != null) {

                        let weightInLbs = this.kgToLbs(productAndRiderDetails.riderData.weight);
                        let weight = parseFloat(weightInLbs.toFixed(2));
                        $('#Weight').val(weight).trigger('change');
                        $('#Weight').text(weight);
                    }
                } else {
                    if ($('#Height').length > 0) {

                        let height = productAndRiderDetails.riderData?.height;

                        this.applyMeterMask($('#Height')[0] as HTMLInputElement);

                        $('#Height').val(height).trigger('change');
                        $('#Height').text(height);
                    }

                    if ($('#Weight').length > 0) {

                        let weight = productAndRiderDetails.riderData.weight;

                        if (weight != undefined || weight != null) {
                            weight = parseFloat(weight.toFixed(2));
                        }

                        $('#Weight').val(weight).trigger('change');
                        $('#Weight').text(weight);
                    }
                }
            }

            resolve();
        });
    }

    hasForm(): boolean {
        if ($(this.formName).length === 0) {
            return false;
        } else {
            return true;
        }
    }

    formIsValid(): boolean {
        let valid = $(this.formName)?.valid();
        return valid;
    }

    setEmptyValues(productAndRiderDetails: models.ProductAndRiderDetails) {
        productAndRiderDetails.riderData = new models.RiderData();
        productAndRiderDetails.riderData.customerName = "name";
        productAndRiderDetails.riderData.customerEmail = "mail";
    }

    private initShoeSizeSystemDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-shoeSizeSystem').length === 0) {
            return;
        }

        this.shoeSizeSystemDropDown = new AxDropdown();
        this.shoeSizeSystemDropDown.init(`.rental_customer_details-shoeSizeSystem`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.shoeSizeSystemDropDown.getValue().toString();
                        if (productAndRiderDetails.riderData.shoeSizeSystem !== Number(value)) {
                            productAndRiderDetails.riderData.shoeSizeSystem = Number(value);
                            this.riderDetailsModule.loadAccountData(productAndRiderDetails.customerAccountNr);
                        }
                    } catch (e) {

                    }
                }
            });

        if (productAndRiderDetails.riderData.shoeSizeSystem != undefined || productAndRiderDetails.riderData.shoeSizeSystem != null) {
            this.shoeSizeSystemDropDown.setValue(productAndRiderDetails.riderData.shoeSizeSystem.toString());
        }
    }

    private initHeightDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-height').length === 0) {
            return;
        }

        this.heightDropDown = new AxDropdown();
        this.heightDropDown.init(`.rental_customer_details-height`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.heightDropDown.getValue().toString();
                        $('#Height').val(value);
                        productAndRiderDetails.riderData.height = Number(value);
                    } catch (e) {

                    }
                }
            });

        if (productAndRiderDetails.riderData.height != undefined || productAndRiderDetails.riderData.height != null) {
            this.heightDropDown.setValue(productAndRiderDetails.riderData.height.toString());
        }
    }

    private initShoeSizeDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-shoeSize').length === 0) {
            return;
        }

        this.shoeSizeDropDown = new AxDropdown();
        this.shoeSizeDropDown.init(`.rental_customer_details-shoeSize`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.shoeSizeDropDown.getValue().toString();
                        $('#ShoeSize').val(value);
                        productAndRiderDetails.riderData.shoeSize = Number(value);
                    } catch (e) {

                    }
                }
            });

        if (productAndRiderDetails.riderData.shoeSize != undefined || productAndRiderDetails.riderData.shoeSize != null) {
            this.shoeSizeDropDown.setValue(productAndRiderDetails.riderData.shoeSize.toString());
        }
    }

    private initWeightDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-weight').length === 0) {
            return;
        }

        this.weightDropDown = new AxDropdown();
        this.weightDropDown.init(`.rental_customer_details-weight`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.weightDropDown.getValue().toString();
                        $('#Weight').val(value);
                        productAndRiderDetails.riderData.weight = Number(value);
                    } catch (e) {

                    }
                }
            });

        if (productAndRiderDetails.riderData.weight != undefined || productAndRiderDetails.riderData.weight != null) {
            this.weightDropDown.setValue(productAndRiderDetails.riderData.weight.toString());
        }
    }

    private initCountryDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-country').length === 0) {
            return;
        }

        this.countryDropDown = new AxDropdown();
        this.countryDropDown.init(`.rental_customer_details-country`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    const value = this.countryDropDown.getValue().toString();
                    $('#CustomerCountry').val(value);
                    productAndRiderDetails.riderData.country = value;
                }
            });

        if (productAndRiderDetails.riderData.country != undefined || productAndRiderDetails.riderData.country != null) {
            this.countryDropDown.setValue(productAndRiderDetails.riderData.country);
        }
    }

    private initGenderDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-gender').length === 0) {
            return;
        }

        this.genderDropDown = new AxDropdown();
        this.genderDropDown.init(`.rental_customer_details-gender`,
            {
                searchBar: true,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    const value = this.genderDropDown.getValue().toString();
                    $('#Gender').val(value);
                    productAndRiderDetails.riderData.gender = value;
                }
            });

        if (productAndRiderDetails.riderData.gender != undefined || productAndRiderDetails.riderData.gender != null) {
            this.genderDropDown.setValue(productAndRiderDetails.riderData.gender);
        }
    }

    private initSkillLevelDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-skillLevel').length === 0) {
            return;
        }

        this.skillLevelDropDown = new AxDropdown();
        this.skillLevelDropDown.init(`.rental_customer_details-skillLevel`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    const value = this.skillLevelDropDown.getValue().toString();
                    $('#SkillLevel').val(value);
                    productAndRiderDetails.riderData.skillLevel = Number(value);
                }
            });

        if (productAndRiderDetails.riderData.skillLevel != undefined || productAndRiderDetails.riderData.skillLevel != null) {
            this.skillLevelDropDown.setValue(productAndRiderDetails.riderData.skillLevel.toString());
        }
    }

    private getValidationRules(): JQueryValidation.RulesDictionary {
        const that = this;
        return {
            hiddenPhone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/
            },
            phone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/,
                normalizer: function (value) {
                    let dropdownVal = $(this).parents(".ax-phone-field").find(".hidden-input").val() as string;
                }
            },
            email: {
                required: true,
                email: true,
                regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
            },
            heightFeet: {
                number: true,
                maxHeight: {
                    maxFeet: 7,
                    maxInches: 0
                }
            },
            heightInch: {
                number: true,
                max: 11,
                maxHeight: {
                    maxFeet: 7,
                    maxInches: 0
                }
            },
            Weight: {
                number: true,
                max: this.unitSystem === 1 ? 400 : 181,
            },
            Height: {
                number: true,
                max: 2.10
            },
        };
    }

    applyMeterMask(inputElement: HTMLInputElement) {
        const meterFormat = "[0].[00]";
        //const feetAndInchesFormat = '9999\'99"';

        const listener = MaskedTextChangedListener.installOn(meterFormat, inputElement,
            new class implements MaskedTextChangedListener.ValueListener {
                public onTextChanged(maskFilled: boolean, extractedValue: string, formattedText: string): void {
                    $('#Height').trigger('input');
                }
            }(),
            [], // affineFormats
            [], // customNotations
            null, // affinityCalculationStrategy
            true // autocomplete
        );
    }

    applyFeetAndInchesMask(inputElement: HTMLInputElement) {
        const feetAndInchesFormat = "[00]' [00]''";
        //const feetAndInchesFormat = '9999\'99"';

        const listener = MaskedTextChangedListener.installOn(feetAndInchesFormat, inputElement,
            new class implements MaskedTextChangedListener.ValueListener {
                public onTextChanged(maskFilled: boolean, extractedValue: string, formattedText: string): void {
                    $()
                }
            }(),
            [], // affineFormats
            [], // customNotations
            null, // affinityCalculationStrategy
            true // autocomplete
        );
    }
}